import { useGet } from '@ngt/opms';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetMriImageUploads, GetMriImageUploadsResponse } from '../api/dtos';
import { useMemo } from 'react';

const getData = (response?: SWRResponse<GetMriImageUploadsResponse, GetMriImageUploadsResponse>) => response?.data?.data;
const getError = (response?: SWRResponse<GetMriImageUploadsResponse, GetMriImageUploadsResponse>) => (response?.error ?? response?.data)?.responseStatus;

export const useGetIMriImageUploads = (
    institutionCode?: string | undefined,
    selectedImagesNotUploaded?: boolean | undefined,
    selectedImagesNotVerified?: boolean | undefined,
    selectedImagesDeidentifiedFailed?: boolean | undefined,
    configuration?: SWRConfiguration | undefined
) => {
    const request = useMemo(() => {
        return () => {
            return new GetMriImageUploads({
                institutionCode: institutionCode,
                selectedImagesNotUploaded: selectedImagesNotUploaded,
                selectedImagesNotVerified: selectedImagesNotVerified,
                selectedImagesDeidentifiedFailed: selectedImagesDeidentifiedFailed,
                noCache: Date.now().toString() 
            });
        }
    }, [institutionCode, selectedImagesNotUploaded, selectedImagesNotVerified, selectedImagesDeidentifiedFailed]);

    const swrConfigDontReValidate = {
        ...configuration,
        revalidateIfStale: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    }

    return useGet(request, { getData, getError }, swrConfigDontReValidate);
}

export default useGetIMriImageUploads;